<template>
  <div class="tw-bg-white tw-rounded-lg tw-p-6">
    <!-- CLOSE BUTTON -->
    <CloseButton @click="closeDialog" />

    <!-- LOGO -->
    <Logo />

    <!-- TITLE -->
    <p
      class="
        tw-text-center tw-font-medium tw-text-base tw-text-black tw-mb-4
        xl:tw-text-2xl
      "
    >
      {{ title }}
    </p>

    <!-- CONTENT -->
    <!-- eslint-disable vue/no-v-html -->
    <p class="tw-mb-5" v-html="content" />
    <!-- eslint-enable vue/no-v-html -->

    <!-- ACTIONS -->
    <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-4">
      <!-- CANCEL -->
      <Button @click="handleCancel">
        {{ cancelText }}
      </Button>

      <!-- CONFIRM -->
      <Button variant="outlined" @click="handleConfirm">
        {{ confirmText }}
      </Button>
    </div>
  </div>
</template>

<script>
import CloseButton from './CloseButton'
import Button from './Button'
import Logo from './Logo'

export default {
  components: { Button, CloseButton, Logo },
  props: {
    title: {
      default: null,
      type: String,
    },
    content: {
      default: null,
      type: String,
    },
    confirmText: {
      default: 'Ok',
      required: false,
      type: String,
    },
    cancelText: {
      default: 'Cancel',
      required: false,
      type: String,
    },
    onConfirm: {
      default: undefined,
      required: false,
      type: Function,
    },
    onCancel: {
      default: undefined,
      required: false,
      type: Function,
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    handleConfirm() {
      this.onConfirm?.()
      this.closeDialog()
    },
    handleCancel() {
      this.onCancel?.()
      this.closeDialog()
    },
  },
}
</script>
